<script>
  export let reviewchannel
  export let showIconOnReview

  const channelWithIcons = [
    'google',
    'facebook',
    'linkedin',
    'pinterest',
    'instagram',
    'yelp'
  ]

  const channelImageSourceMap = {
    kudobuzz: 'https://statics2.kudobuzz.com/icons/kudobuzz_icon_logo@1x.png',
    etsy: 'https://statics2.kudobuzz.com/icons/etsy.svg',
    amazon: 'https://statics2.kudobuzz.com/icons/amazon.png'
  }

  const channel = platform =>
    `kudobuzz_${platform === 'kudobuzz' ? 'logo' : platform}_icon`

  $: showIcon = showIconOnReview
    ? 'kb-icon__review-bottom'
    : 'kb-icon__card-bottom'
</script>

<style>
  .kudobuzz_facebook_icon::before {
    content: '\e804';
    color: #3b5998;
  }

  .kudobuzz_google_icon::before {
    content: '\e805';
    color: #db4a39;
  }

  .kudobuzz_linkedin_icon::before {
    content: '\e806';
    color: #0e76a8;
  }

  .kudobuzz_pinterest_icon::before {
    content: '\e807';
    color: #c8232c;
  }

  .kudobuzz_instagram_icon::before {
    content: '\e818';
    color: white;
    background: radial-gradient(
      circle at 30% 107%,
      #fdf497 0%,
      #fdf497 5%,
      #fd5949 45%,
      #d6249f 60%,
      #285aeb 90%
    );
  }

  .kudobuzz_twitter_icon::before {
    content: '\e808';
    color: #00acee;
  }

  .kudobuzz_yelp_icon::before {
    content: '\e809';
    color: #c41200;
  }

  :global(._1V2dn) {
    margin: 5px;
    font-size: 20px;
    width: 24px;
    height: 24px;
  }

  .kb-icon__card-bottom {
    position: absolute;
    right: 5px;
    bottom: 5px;
  }

  .kb-icon__review-bottom {
    margin-left: auto;
    display: flex;
  }

  .kudobuzz_logo_icon {
    width: 21px;
    height: 27px;
  }

  .kudobuzz_etsy_icon {
    width: 15px;
    height: 24px;
  }

  .kudobuzz_amazon_icon {
    width: 23px;
    height: 23px;
  }
</style>

{#if reviewchannel.length !== 0}
  {#if channelWithIcons.includes(reviewchannel)}
    <span class="_1V2dn kudobuzz_icon {channel(reviewchannel)}" />
  {:else if Object.keys(channelImageSourceMap).includes(reviewchannel)}
    <img
      class="_1V2dn {channel(reviewchannel)}
      {showIcon}"
      src={channelImageSourceMap[reviewchannel]}
      alt={reviewchannel} />
  {/if}
{/if}
